import { useReactiveVar } from '@apollo/client';
import { Avatar, AvatarLetter, AvatarList } from '@pocketlaw/tetris';
import { documentUsers } from 'shared/domains/documents';
import { useFeatureFlag } from 'shared/domains/featureFlag';
export function ActiveUsers() {
    const isRTC = useFeatureFlag('feature_rtc_pleditor');
    const users = useReactiveVar(documentUsers);
    if (!isRTC || !users.length) {
        return null;
    }
    return (<AvatarList avatars={users.map(user => ({
            id: user.id,
            component: (<Avatar solid>
            <AvatarLetter>{user.name.slice(0, 1)}</AvatarLetter>
          </Avatar>),
        }))}/>);
}
